import { render, staticRenderFns } from "./reportLogTable.vue?vue&type=template&id=51bfa39e&scoped=true"
import script from "./reportLogTable.vue?vue&type=script&lang=js"
export * from "./reportLogTable.vue?vue&type=script&lang=js"
import style0 from "./reportLogTable.vue?vue&type=style&index=0&id=51bfa39e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51bfa39e",
  null
  
)

export default component.exports